/* eslint-disable no-unused-vars */
import Flickity from 'flickity'

export default function studioSliders () {
  const aboutOptions = {
    wrapAround: true,
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: true,
    fade: true,
    lazyLoad: 3,
  }
  // if (matchMedia('screen and (min-width: 800px)').matches) {
  //   aboutOptions.cellAlign = 'left'
  // }
  const aboutSliders = document.querySelectorAll('.js-image-slides')
  for (let i = 0; i < aboutSliders.length; i++) {
    const flickity = new Flickity(aboutSliders[i], aboutOptions)
  }
}
